"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var router_deprecated_1 = require('@angular/router-deprecated');
var clientinfo_service_1 = require('../../clientinfo.service');
var core_2 = require('angular2-cookie/core');
var http_1 = require('@angular/http');
var WelcomeComponent = (function () {
    function WelcomeComponent(router, clientInfo, _cookieService, http) {
        this.router = router;
        this.clientInfo = clientInfo;
        this._cookieService = _cookieService;
        this.http = http;
        this.isEng = true;
        this.authCode = '';
        this.isValidCode = false;
        this.isSending = false;
    }
    WelcomeComponent.prototype.ngOnInit = function () { };
    WelcomeComponent.prototype.switchLocale = function () {
        this.isEng = !this.isEng;
    };
    WelcomeComponent.prototype.validateCode = function (value) {
        this.authCode = value;
        if (this.authCode.length < 6) {
            this.isValidCode = false;
        }
        else {
            this.isValidCode = true;
        }
    };
    WelcomeComponent.prototype.makeOrderByCode = function () {
        var _this = this;
        this.isSending = true;
        this.clientInfo.userOrder.code = this.authCode;
        var headers = new http_1.Headers();
        headers.append('Content-Type', 'application/json');
        this.http.post('/api/user/makeorderbycode', JSON.stringify(this.clientInfo.userOrder), { headers: headers })
            .map(function (response) { return response.json(); })
            .subscribe(function (response) {
            _this.isSending = false;
            if (response.code == 1) {
                _this.addUserToken();
                _this.router.navigate(['CodeSuccess']);
            }
            else {
                _this.router.navigate(['CodeError']);
            }
        });
    };
    WelcomeComponent.prototype.addUserToken = function () {
        var _this = this;
        var headers = new http_1.Headers();
        headers.append('Content-Type', 'application/json');
        this.http.post('/api/user/addtoken', JSON.stringify(this.clientInfo.userOrder), { headers: headers })
            .map(function (response) { return response.json(); })
            .subscribe(function (data) {
            _this._cookieService.put("token" + data.service_id, data.token);
        });
    };
    WelcomeComponent = __decorate([
        core_1.Component({
            selector: 'smartwifi-welcome',
            // templateUrl: './app/steps/welcome/welcome.template.html',
            template: require('./welcome.template.html'),
            directives: [router_deprecated_1.ROUTER_DIRECTIVES]
        }), 
        __metadata('design:paramtypes', [(typeof (_a = typeof router_deprecated_1.Router !== 'undefined' && router_deprecated_1.Router) === 'function' && _a) || Object, (typeof (_b = typeof clientinfo_service_1.ClientInfoService !== 'undefined' && clientinfo_service_1.ClientInfoService) === 'function' && _b) || Object, (typeof (_c = typeof core_2.CookieService !== 'undefined' && core_2.CookieService) === 'function' && _c) || Object, (typeof (_d = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _d) || Object])
    ], WelcomeComponent);
    return WelcomeComponent;
    var _a, _b, _c, _d;
}());
exports.WelcomeComponent = WelcomeComponent;



/*****************
 ** WEBPACK FOOTER
 ** ./app/steps/welcome/welcome.component.ts
 ** module id = 935
 ** module chunks = 1
 **/